import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import ComposerActionCreators from '~publish/legacy/composer/composer/action-creators/ComposerActionCreators'
import { isSelectionChangeOnly } from '~publish/components/Composer/components/EditorSurface/isSelectionChangeOnly'
import { getOmniWriteTarget } from '~publish/components/Composer/store/bridge/omniWriteTarget'

import { getPlainText } from '../BufferEditor/getPlainText'
import type { BufferEditor } from '../BufferEditor/types.plate'

export const TEXT_SYNC_PLUGIN_KEY = 'text-sync-plugin'

// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createTextSyncPlugin = (): AnyPlatePlugin => {
  const plugin = createPlatePlugin({
    key: TEXT_SYNC_PLUGIN_KEY,
    handlers: {
      onChange: ({ editor }): void => {
        const bufferEditor = editor as unknown as BufferEditor

        // Skip for selection-only changes — text hasn't changed
        if (isSelectionChangeOnly(bufferEditor)) {
          return
        }

        if (bufferEditor.id === 'omni') {
          const target = getOmniWriteTarget()
          if (target) {
            // With the target registered, Zustand receives the text and the
            // Zustand→Flux mirror writes `draft.text`. The legacy
            // `updateDraftEditorState` path also still writes `draft.text`
            // directly; both paths converge on identical values and the
            // mirrors' diff gates make the second arrival a no-op.
            target.getState().setOmniText({ text: getPlainText(bufferEditor) })
            return
          }
        }

        ComposerActionCreators.updatePostText(
          bufferEditor.id,
          getPlainText(bufferEditor),
        )
      },
    },
  })
  return plugin
}
